export default "__VITE_ASSET__OQpXNbDL__"